module.exports = __webpack_public_path__ + "img/truck-booking.48061c65.svg";